import { IDropdownItem } from '@dcl/ui/dist/modules/Dropdown';
import { ReactNode } from 'react';
import { IProductListItem } from '../types';

export const filterProduct = (
  value: string,
  productList: IProductListItem[]
) => {
  const selected = productList.filter((item: IProductListItem) =>
    value.includes(item.value)
  );

  if (selected.length) return selected[0].value;

  return '';
};

export const filterFn = (
  items: IDropdownItem[],
  value: ReactNode
): IDropdownItem[] => {
  if (typeof value !== 'string') return [];

  const label = value.toLowerCase();

  return items.filter((item) => item.label.toLowerCase().includes(label));
};
